import { useEffect, useRef } from "react";

interface GoogleLoginButtonProps {
  onSuccess: (credential: string) => void;
  onError?: (error: any) => void;
  disabled?: boolean;
  text?: string;
}

export function GoogleLoginButton({
  onSuccess,
  onError,
  disabled = false,
}: GoogleLoginButtonProps) {
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const initializeGoogleSignIn = () => {
      if (buttonRef.current && google.accounts) {
        google.accounts.id.initialize({
          client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
          callback: (response: any) => {
            if (response.credential) {
              onSuccess(response.credential);
            } else {
              onError?.(new Error("No credential received from Google"));
            }
          },
          auto_select: false,
          cancel_on_tap_outside: true,
        });
  
        google.accounts.id.renderButton(buttonRef.current, {
          type: "standard",
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "rectangular",
          width: 400,
        });
        clearInterval(interval)
      }
    }

    const interval = setInterval(() => {
      initializeGoogleSignIn();
    }, 100);
    return () => clearInterval(interval);

  }, []);
  
  return (
    <div
      ref={buttonRef}
      className={`${disabled ? "pointer-events-none opacity-50" : ""}`}
    />
  );
}
